import React, { useMemo } from 'react';
import { DynamicImage, enLoading, LoadingType } from 'components/Image';
import { isMobileBrowser, isNotEmpty } from 'utility/functions';
import styles from './BannerContent.module.scss';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { Banner, BannerImages } from 'components/banner';

export type BannerContentProps = {
  loading?: LoadingType;
  children?: React.ReactNode;
  bannerContent: Partial<Banner> & {
    srcImage: Partial<BannerImages>;
  };
};

export const BannerContent: React.FC<BannerContentProps> = ({
  bannerContent,
  children,
  loading = enLoading.lazy,
}: BannerContentProps) => {
  const labelPromo = useGetLabelByKey('promo')!;

  const { alt, title, subtitle, isPromo, portraitImg, landscapeImg } = useMemo(() => {
    const isMobile = isMobileBrowser();

    const { srcImage, isPromo, title, subtitle } = bannerContent ?? {};
    const { landscape, portrait, alt } = srcImage ?? {};
    const { srcDesktop, srcMobile } = landscape ?? {};

    const src = isMobile ? srcMobile : srcDesktop;
    const fallback = isMobile ? srcDesktop : srcMobile;

    return { alt, title, subtitle, isPromo, portraitImg: portrait?.src, landscapeImg: src ?? fallback };
  }, [bannerContent]);

  return (
    <React.Fragment>
      {isPromo && <div className={styles.label}>{labelPromo}</div>}
      <div className={styles.wrapper}>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.subtitle}>{subtitle}</p>
        {children}
      </div>
      <div className={styles.imageContainer}>
        {isNotEmpty(landscapeImg) && (
          <DynamicImage
            alt={alt ?? ''}
            src={landscapeImg}
            fill
            loading={loading}
            priority={loading === enLoading.eager}
            decoding="async"
            className={styles.image}
            role="presentation"
          />
        )}
        {isNotEmpty(portraitImg) && (
          <DynamicImage
            alt={alt ?? ''}
            src={portraitImg}
            fill
            loading={loading}
            decoding="async"
            priority={loading === enLoading.eager}
            className={styles.image}
          />
        )}
      </div>
    </React.Fragment>
  );
};
